module.exports = __webpack_public_path__ + "static/media/OpenSans_Bold.1025a6e0.ttf";